import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal, FadeIn } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { LEGAL } from "@/data/legal";

const Legal = ({ page }) => {
  const doc = LEGAL[page];
  const other = page === "terms" ? LEGAL.privacy : LEGAL.terms;
  const otherTo = page === "terms" ? "/privacy" : "/terms";

  return (
    <div data-testid={`${page}-page`}>
      <Seo title={`${doc.title} — TecKube`} description={doc.description} />
      <PageHero eyebrow="Legal" title={doc.title}>
        <FadeIn delay={0.35}>
          <p className="mt-6 text-sm text-soot" data-testid={`${page}-amended`}>
            Document amended {doc.amended}
          </p>
        </FadeIn>
      </PageHero>

      <section className="bg-paper pb-24 md:pb-32" data-testid={`${page}-body`}>
        <div className="mx-auto max-w-3xl px-6">
          {doc.sections.map((section, i) => (
            <Reveal key={section.id} delay={Math.min(i * 0.03, 0.12)}>
              <div
                id={section.id}
                className="border-t border-slate-200 py-10 first:border-t-0 first:pt-0"
                data-testid={`${page}-section-${section.id}`}
              >
                <h2 className="font-display text-xl font-semibold tracking-tight text-ink md:text-2xl">
                  {section.heading}
                </h2>
                <div className="mt-5 space-y-4">
                  {section.body.map((paragraph, j) => (
                    <p key={j} className="text-[15.5px] leading-relaxed text-soot">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.1}>
            <div className="rounded-3xl border border-slate-200 bg-white p-8 md:p-10">
              <p className="font-display text-lg font-semibold tracking-tight text-ink">
                Read also
              </p>
              <div className="mt-5 flex flex-wrap gap-4">
                <Link
                  to={otherTo}
                  data-testid={`${page}-other-legal-link`}
                  className="btn btn-ghost px-6 py-3 text-sm"
                >
                  {other.title}
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <Link
                  to="/contact"
                  data-testid={`${page}-contact-link`}
                  className="btn btn-ghost px-6 py-3 text-sm"
                >
                  Contact TecKube
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Legal;
